import $ from "jquery"
import jQuery from "jquery"
import lodash from "lodash"
import Handlebars from "@cirrus/legacy/vendor-bower/handlebars/handlebars"

var Utils = {}

Utils.initCheckboxes = function () {
  $("input[type=checkbox]").parents("label.disabled").removeClass("disabled")
  $("input[type=checkbox]:disabled").parents("label").addClass("disabled")
  $("input[type=checkbox]").each(function () {
    var isChecked = $(this).prop("checked")
    // if (!isChecked) return;
    Utils.toggleCheckbox($(this))
  })
}

Utils.toggleCheckbox = function (checkbox) {
  var isChecked = checkbox.prop("checked")
  if (isChecked) {
    checkbox.parents("label:first").addClass("checked")
  } else {
    checkbox.parents("label:first").removeClass("checked")
  }
}

Utils.merge = function (obj1, obj2) {
  var obj3 = {}
  for (var attrname in obj1) {
    obj3[attrname] = obj1[attrname]
  }
  for (var attrname in obj2) {
    obj3[attrname] = obj2[attrname]
  }
  return obj3
}

Utils.fixDateTime = function (obj, propName) {
  try {
    obj[propName] = new Date(parseInt(obj[propName].replace("/Date(", "").replace(")/", ""), 10))
  } catch (e) {
    // Seems it's normal DateTime. Nasty, but works.
  }
}

Utils.generateID = function () {
  var s4 = function () {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return s4() + s4() + s4()
}

Utils.generateZones = function (region) {
  var zones = moment.tz.names()

  var result = []
  _.each(zones, function (zone) {
    var r = new RegExp("(^" + region + "/)", "gm")
    if (!r.test(zone)) return

    var offset = moment.tz(zone).format("Z")
    var zoneObject = { id: zone, name: zone.replace(r, ""), zone: offset }
    result.push(zoneObject)
  })
  return result
}

Utils.MSIVersion = function msieversion() {
  var ua = window.navigator.userAgent
  var msie = ua.indexOf("MSIE ")

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
    // If Internet Explorer, return version number
    return true
  //alert(parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
  // If another browser, return 0

  //alert('otherbrowser');
  return false
}

export const cleanFromBlanks = function (text) {
  const div = $("<div/>")
  div.html(text)
  $(div).find(".combobox").replaceWith("")
  $(div).find("select").replaceWith("")
  $(div).find("input").replaceWith("")

  return div[0].innerHTML
}

Utils.removeTags = function (raw) {
  var div = $("<div/>")

  var temp = div.html(
    raw
      .replace(/#\\/g, "")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/alert\(.*\)/g, "")
      .replace(/src\=.+?>/g, ">")
      .replace(/src\=.+?\s/g, " ")
      .replace("&nbsp;", " "),
  )
  temp
    .find('script[type="math/mml"]')
    .replaceWith(
      '<span class="text-italic">' + Handlebars.Utils.escapeExpression("[formula]") + "</span>",
    )
  temp
    .find("audio")
    .replaceWith(
      '<span class="text-italic">' + Handlebars.Utils.escapeExpression("[audio]") + "</span>",
    )
  temp
    .find("img")
    .replaceWith(
      '<span class="text-italic">' + Handlebars.Utils.escapeExpression("[image]") + "</span>",
    )
  temp
    .find("video")
    .replaceWith(
      '<span class="text-italic">' + Handlebars.Utils.escapeExpression("[video]") + "</span>",
    )
  temp
    .find("iframe")
    .replaceWith("<span>" + Handlebars.Utils.escapeExpression("[video]") + "</span>")
  temp
    .find("a")
    .replaceWith(
      '<span class="text-italic">' + Handlebars.Utils.escapeExpression("[link]") + "</span>",
    )
  temp
    .find("div.locationmap")
    .replaceWith(
      '<span class="text-italic">' + Handlebars.Utils.escapeExpression("[map]") + "</span>",
    )
  temp
    .find("div.embeddedContent")
    .replaceWith(
      '<span class="text-italic">' + Handlebars.Utils.escapeExpression("[embedded]") + "</span>",
    )
  temp
    .find("table")
    .replaceWith(
      '<span class="text-italic">' + Handlebars.Utils.escapeExpression("[table]") + "</span>",
    )
  temp.find("script").replaceWith("")
  temp.find("br").replaceWith("")
  return temp
}

Utils.clearSurveyQuestion = function (raw) {
  if (!raw) return ""
  var temp = Utils.removeTags(raw)

  var text = jQuery("<p>" + temp.text() + "</p>").text()
  text = text.replace(/(\r\n|\n|\r)/gm, " ").replace(/\s+/g, " ")
  return lodash.trim(text)
}

/**
 * @deprecated Use cleanHtmlToText from @cirrus/common/questions/utils instead
 * This function limits output to 200 characters and returns HTML, which may not be desired.
 * For plain text extraction without length limits, use: import { cleanHtmlToText } from "@cirrus/common/questions/utils"
 */
export const cleanString = function (raw) {
  if (!raw)
    return (
      '<span class="text-italic">' + Handlebars.Utils.escapeExpression("<Untitled>") + "</span>"
    )
  var temp = Utils.removeTags(raw)
  var text = temp
    .text()
    .replace(/(\r\n|\n|\r)/gm, "")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
  if (!lodash.trim(text))
    return (
      '<span class="text-italic">' + Handlebars.Utils.escapeExpression("<Untitled>") + "</span>"
    )

  text = jQuery("<p>" + temp.text() + "</p>").text()
  return text.length > 200 ? text.slice(0, 200) + "..." : text
}

/**
 * @deprecated Use cleanHtmlToText from @cirrus/common/questions/utils instead
 * This function limits output to 200 characters and returns HTML, which may not be desired.
 * For plain text extraction without length limits, use: import { cleanHtmlToText } from "@cirrus/common/questions/utils"
 */
Utils.cleanString = cleanString

Utils.isTagsEmpty = function (str) {
  if (!str) return true
  var temp = Utils.removeTags(str)
  var text = temp
    .text()
    .replace(/&nbsp;/gi, "")
    .replace(/<br\s*[\/]?>/gi, "")
    .replace(/<!--(.|\s)*?-->/gi, "")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
  return lodash.trim(text).length === 0
}

Utils.cleanStringText = function (raw) {
  if (!raw)
    return (
      '<span class="text-italic">' + Handlebars.Utils.escapeExpression("<Untitled>") + "</span>"
    )
  var temp = Utils.removeTags(raw)
  var text = temp
    .text()
    .replace(/(\r\n|\n|\r)/gm, "")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
  if (!lodash.trim(text))
    return (
      '<span class="text-italic">' + Handlebars.Utils.escapeExpression("<Untitled>") + "</span>"
    )

  text = jQuery("<p>" + temp.text() + "</p>").text()
  return text
}

Utils.cleanNotificationString = function (raw) {
  var temp = $("<div/>").html(raw)
  temp
    .find("audio")
    .replaceWith("<span>" + Handlebars.Utils.escapeExpression("[audio]") + "</span>")
  temp.find("img").replaceWith("<span>" + Handlebars.Utils.escapeExpression("[image]") + "</span>")
  temp
    .find("video")
    .replaceWith("<span>" + Handlebars.Utils.escapeExpression("[video]") + "</span>")
  temp
    .find("table")
    .replaceWith(
      '<span class="text-italic">' + Handlebars.Utils.escapeExpression("[table]") + "</span>",
    )
  temp.find("br").replaceWith("")
  var text = temp.html().replace(/(\r\n|\n|\r)/gm, "")
  if (!lodash.trim(text))
    return (
      '<span class="text-italic">' + Handlebars.Utils.escapeExpression("<Untitled>") + "</span>"
    )
  return text
}

Utils.trimString = function (raw) {
  if (!raw) return null
  var temp = $("<div/>").html(raw)
  if (temp.find("audio").length > 0) return raw
  if (temp.find("img").length > 0) return raw
  if (temp.find("video").length > 0) return raw
  if (temp.find("table").length > 0) return raw
  if (temp.find("script").length > 0) return raw
  if (temp.find("iframe").length > 0) return raw
  if (temp.find("a")) {
    temp.find("a").each(function () {
      $(this).replaceWith($(this).text())
    })
  }
  var text = temp
    .html()
    .replace("-", "-&#8203;")
    .replace("_", "_&#8203;")
    .replace("+", "+&#8203;")
    .replace("&nbsp;", " ")
  return text.length > 200 ? text.slice(0, 200) + "..." : text
}

Utils.getCheckedCount = function (el) {
  var c = 0
  $(el).each(function () {
    var isChecked = $(this).prop("checked")
    if (isChecked) {
      c++
    }
  })
  return c
}

Utils.getChecked = function (el, getter) {
  var r = []
  if (!(getter && typeof getter === "function")) return

  $(el).each(function () {
    var isChecked = $(this).prop("checked")
    if (isChecked) {
      r.push(getter($(this)))
    }
  })
  return r
}

Utils.isNumberKey = function (e) {
  var val = String.fromCharCode(e.which)
  if ((_.isNaN(Number(val)) || val === " ") && e.which !== 8) e.preventDefault()
}

Utils.isNumberWithNegativeNumberKey = function (e, max) {
  var val = String.fromCharCode(e.which)
  var val2 = $(e.target).val() + val
  if (
    (_.isNaN(Number(val)) || val === " " || val2 < 0 || val2 > max) &&
    e.which !== 8 &&
    e.which !== 45
  )
    e.preventDefault()
}

Utils.isNumberToHKey = function (e) {
  if (e.which === 8) return
  var val = String.fromCharCode(e.which)
  var position = $(e.target).getCursorPosition()
  var val2 =
    position === 0
      ? val + $(e.target).val()
      : [$(e.target).val().slice(0, position), val, $(e.target).val().slice(position)].join("")
  val2 = e.which !== 44 && e.which !== 46 ? val2 : val2 + 0
  if ($(e.currentTarget)[0].selectionStart !== $(e.currentTarget)[0].selectionEnd) {
    var s
    if ($(e.currentTarget)[0].selectionStart === 0) {
      s = $(e.currentTarget)
        .val()
        .substr($(e.currentTarget)[0].selectionStart, $(e.currentTarget)[0].selectionEnd)
    } else {
      s = $(e.currentTarget)
        .val()
        .substr($(e.currentTarget)[0].selectionStart, $(e.currentTarget)[0].selectionEnd - 1)
    }
    val2 = $(e.currentTarget).val().replace(s, val)
    if (!val2) {
      if ((_.isNaN(Number(val)) || val === " ") && e.which !== 44 && e.which !== 46)
        e.preventDefault()
      return
    }
  }
  var regex = /^[0-9]{1,2}([,.]([0-9]{1,2})?)?$|^100([,.](0{1,2})?)?$/
  if (
    ((_.isNaN(Number(val)) || val === " " || val2 < 0) && e.which !== 44 && e.which !== 46) ||
    !regex.test(val2)
  )
    e.preventDefault()
}

Utils.isDoubleValue = (value, options = {}) => {
  const { decimalPoint = ".", maxIntegerNumbers = 10, maxFractionalNumbers = 10 } = options

  const regex = new RegExp(
    `^[+-]?[0-9]{1,${maxIntegerNumbers}}([${decimalPoint}]([0-9]{0,${maxFractionalNumbers}})?)?$|^-$`,
  )

  return regex.test(value)
}

Utils.isNumberAndLengthKey = function (e, max) {
  var val = String.fromCharCode(e.which)
  var val2 = $(e.target).val() + val
  if (!rightKeyCode(e.which) || val2 < 0 || val2 > max) e.preventDefault()

  function rightKeyCode(code) {
    return code === 8 || (code >= 37 && code <= 40) || code === 0 || (code >= 48 && code <= 57)
  }
}
Utils.isNoSpecial = function (value) {
  return /^[-,_,A-Za-z0-9]*$/.test(value)
}

Utils.generateModalMaxHeight = function ($el, loadingEl) {
  var $modalDialog = $el.closest(".modal-dialog")
  var environmentHeight =
    $modalDialog.find(".modal-footer").outerHeight() +
    $modalDialog.find(".modal-header").outerHeight()
  if (loadingEl) {
    var intervalId = setInterval(function () {
      if ($el.find(loadingEl).length !== 0) {
        clearInterval(intervalId)
        setMaxHeight()
      }
    }, 5)
  } else {
    setMaxHeight()
  }

  function setMaxHeight() {
    $modalDialog.css(
      "max-height",
      $modalDialog.find(".modal-body > div").outerHeight() + environmentHeight + 90,
    )
  }
}

const isSpaceOrEmpty = function (value) {
  if (typeof value === "undefined") return true
  if (!value) return true
  value = value.toString()
  try {
    return !value
      .replace(/&nbsp;/gi, "")
      .replace(/<br\s*[\/]?>/gi, "")
      .replace(/<!--(.|\s)*?-->/gi, "")
      .replace(/[\u200B-\u200D\uFEFF]/g, "")
      .trim().length
  } catch (e) {
    return false
  }
}

Utils.isSpaceOrEmpty = isSpaceOrEmpty

export { isSpaceOrEmpty }

Utils.getTime = function (seconds) {
  var min = Math.floor(Number(seconds / 60))
  var sec = seconds % 60
  if (min < 0) min = 0
  if (sec < 0) sec = 0

  if (sec < 10) sec = "0" + sec
  if (min < 10) min = "0" + min
  return min + ":" + sec
}

Utils.dtDayMonthYearTime = function (dt, extra) {
  if (dt) {
    return Utils.getMoment(dt).format("L LT")
  }
  return ""
}

export const dtDayMonthYearShortTime = function (dt) {
  if (dt) {
    return Utils.getMoment(dt).format("L LT")
  }

  return "-"
}

Utils.dtDayMonthYearShortTime = dtDayMonthYearShortTime

export const getDayMonthYearShortTime = function (dt) {
  return Utils.getMoment(dt).format("D MMMM YYYY h:mm")
}

Utils.getDayMonthYearShortTime = getDayMonthYearShortTime

export const dtDayMonthYear = function (dt) {
  return Utils.getMoment(dt).format("L")
}

Utils.dtDayMonthYear = dtDayMonthYear

export const dtMonthNameDayYear = function (dt) {
  return Utils.getMoment(dt).format("MMMM D, YYYY")
}

Utils.dtMonthNameDayYear = dtMonthNameDayYear

/**
 * @return {string}
 */
export const ShortTime = function (dt) {
  return Utils.getMoment(dt).format("LT")
}

Utils.ShortTime = ShortTime

Utils.getMoment = function (dt) {
  if (!dt) return moment()

  if (!App.regionalSettings || !App.regionalSettings.zone) return moment.utc(dt)

  return moment.utc(
    (moment.utc(dt).unix() + moment.tz(App.regionalSettings.zone).utcOffset() * 60) * 1000,
  )
}

Utils.getMomentByDateTimeZone = function (dt) {
  if (!dt) return moment()

  if (!App.regionalSettings || !App.regionalSettings.zone) return moment.utc(dt)

  return moment.utc(
    (moment.utc(dt).unix() + moment.tz(dt, App.regionalSettings.zone).utcOffset() * 60) * 1000,
  )
}

Utils.formatFloat = function (number, language) {
  return parseFloat(number).toFixed(2).toLocaleString(language)
}

export const statusBox = function (status) {
  if (!status || !status.split) return ""
  var parts = status.split(":")
  var key = parts[1]
  return key.toLowerCase()
}

Utils.statusBox = statusBox

Utils.getDuration = function (dtStart, dtEnd) {
  var val = new Date(dtEnd) - new Date(dtStart)
  return moment.duration(val)
}

export function formatTime(min) {
  if (!_.isNumber(min) || min === 0) return "0 " + App.Text.get("Timer.Minutes.Short", "General")
  var days = parseInt(min / 1440)
  var hours = parseInt((min - days * 1440) / 60)
  var minutes = min - hours * 60 - days * 1440
  var result = []
  if (days) result.push(days + App.Text.get("Timer.Days.Short", "General"))
  if (hours) result.push(hours + App.Text.get("Timer.Hours.Short", "General"))
  if (minutes) result.push(minutes + App.Text.get("Timer.Minutes.Short", "General"))
  return result.join(" ")
}
Utils.formatTime = formatTime

Utils.formatTimeInMinutes = function (min) {
  if (!_.isNumber(min) || min === 0) return "0 " + App.Text.get("Timer.Minutes.Short", "General")
  return min + App.Text.get("Timer.Minutes.Short", "General")
}

Utils.getBrowserInfo = function () {
  var ua = navigator.userAgent,
    tem,
    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || []
    return { name: "IE ", version: tem[1] || "" }
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\bOPR\/(\d+)/)
    if (tem != null) {
      return { name: "Opera", version: tem[1] }
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"]
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1])
  }
  return {
    name: M[0],
    version: M[1],
  }
}

function getScoreText(alertClass, score, totalScore) {
  var scoreText = '<div class="cmn-score ' + alertClass + ' total-score">' + score + "</div>"
  var totalScoreText = '<span class="max-score">' + totalScore + "</span>"
  return App.Text.get("OfPreposition", "General")
    .replace("{0}", scoreText)
    .replace("{1}", totalScoreText)
}

Utils.getTotalScoreHtml = function (score, totalScore, isMarked) {
  var alertClass = "cmn-score-neutral"
  var text
  if (!isMarked) {
    text = getScoreText(alertClass, "-", totalScore)
    return text
  }

  score = Number(score.toString().replace(",", "."))
  totalScore = Number(totalScore.toString().replace(",", "."))

  if (score <= 0) alertClass = "cmn-score-danger"
  if (0 < score && score < totalScore) alertClass = "cmn-score-warning"
  if (score >= totalScore) alertClass = "cmn-score-success"

  score = lodash.round(score, 2)
  text = getScoreText(alertClass, score, totalScore)
  return text
}

Utils.fixSowisoTextValue = function (value) {
  if (!value || !value.replace) return null
  var $container = $("<div></div>")
  $container.append(value.replace(/&lt;/g, "<").replace(/&gt;/g, ">"))
  var $table = $("table", $container)
  $table.addClass("sowisoTableFix")
  return $container.html()
}

Utils.encodeURIComponent = function (str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
    return "%" + c.charCodeAt(0).toString(16)
  })
}

Utils.convertToNumberingScheme = function (number) {
  var baseChar = "A".charCodeAt(0),
    letters = ""

  do {
    number -= 1
    letters = String.fromCharCode(baseChar + (number % 26)) + letters
    number = (number / 26) >> 0
  } while (number > 0)

  return letters
}

export default Utils
